import { render, staticRenderFns } from "./ExportClientChurnModal.vue?vue&type=template&id=66081718&scoped=true"
import script from "./ExportClientChurnModal.vue?vue&type=script&lang=ts"
export * from "./ExportClientChurnModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66081718",
  null
  
)

export default component.exports